import script from "./GlossaryNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./GlossaryNavigation.vue?vue&type=script&setup=true&lang=js"

import "./GlossaryNavigation.vue?vue&type=style&index=0&id=cfaf26b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfaf26b2"]])

export default __exports__